import React from 'react';
import { useParams } from 'react-router-dom';
import { ProFormCheckbox, ProFormTextArea } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import ProForm from 'components/layout/ProForm';
import { FormUpload } from 'components/input';
import {
  ENUM_PROPOSAL_REVISION_CHANGES_INCLUDED,
  WIDTH_2_COL,
} from 'constants/form';
import objMap from 'utils/objMap';

const convertEnumToOptions = objMap((key, value) => ({
  value: key,
  label: value,
}));

const ProposalRevisionForm = ({ onFinish, initialValues, disabled }) => {
  const { projectId } = useParams();

  return (
    <ProForm
      disabled={disabled}
      initialValues={initialValues}
      previousLevel={`/projects/${projectId}/proposal-revisions`}
      onFinish={onFinish}
    >
      <FormUpload
        maxCount={1}
        name="revisedProposal"
        label="Revised Proposal"
        rules={[{ required: true, message: 'Please upload file!' }]}
        projectId={projectId}
        subFolder="PROPOSAL_REVISION"
        disabled={disabled}
      />
      <FormUpload
        disabled={disabled}
        maxCount={5}
        name="supportingDocuments"
        label="Supporting Document(s)"
        projectId={projectId}
        subFolder="PROPOSAL_REVISION"
        multiple
      />
      <ProFormCheckbox.Group
        disabled={disabled}
        name="changesIncluded"
        layout="vertical"
        label="Please check all changes included"
        options={convertEnumToOptions(ENUM_PROPOSAL_REVISION_CHANGES_INCLUDED)}
      />
      <ProFormTextArea
        disabled={disabled}
        width={WIDTH_2_COL}
        name="highlights"
        label="Highlights of Change"
        rules={[{ required: true, message: 'Please enter justification!' }]}
      />
      <ProFormTextArea
        disabled={disabled}
        width={WIDTH_2_COL}
        name="justification"
        label="Justification"
        rules={[{ required: true, message: 'Please enter justification!' }]}
      />
    </ProForm>
  );
};

ProposalRevisionForm.defaultProps = {
  initialValues: {},
  disabled: false,
};

ProposalRevisionForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ProposalRevisionForm;
